(ns frontend.ui.component.lp-portal.footer.view
  (:require
   [clojure.string :as string]
   [common.util :as cu]
   [re-frame.core :as rf]
   [reitit.frontend.easy :as reitit-e]
   [frontend.ui.component.lp-portal.footer.style :as style]
   [herb.core :refer [<class]]
   [frontend.lp-portal.sub :as portal-sub]
   [frontend.lp-portal.routes :as routes]))

(defn footer
  []
  (let [tenant @(rf/subscribe [::portal-sub/tenant])
        year (-> (js/Date.)
                 (.getFullYear))
        tenant-name (:tenant/name tenant)
        hidden? (some #{(cu/str-trim-lcase tenant-name)} ["voima ventures" "voima" "sparkmind" "innovestor"
                                                          "lifeline ventures"])]
    [:div {:class (<class style/footer)}
     [:div
      {:class (<class style/footer-inner)}
      [:div
       {:class (<class style/copyright-desktop)}
       (str "COPYRIGHT © "
            year
            " "
            (string/upper-case (:tenant/name tenant))
            ". ALL RIGHTS RESERVED.")]
      [:div {:class (<class style/links)}
       (when-not hidden?
         [:a
          {:class (<class style/link)
           :href  (reitit-e/href ::routes/glossary)}
          "GLOSSARY"])
       [:a
        {:class (<class style/link)
         :href  (reitit-e/href ::routes/disclaimer)}
        "DISCLAIMER"]
       [:a
        {:class  (<class style/link)
         :href   (str "mailto:" (:tenant/reporting-contact-email tenant))
         :target "_blank"}
        "CONTACT US"]]
      [:div
       {:class (<class style/mobile-right-container)}
       [:div
        {:class (<class style/copyright-mobile)}
        [:span
         {:class (<class style/copyright-part)}
         (str "COPYRIGHT © " year " " (string/upper-case (:tenant/name tenant)) ".")]
        [:span
         {:class (<class style/copyright-part)}
         "ALL RIGHTS RESERVED."]]
       [:div
        {:class (<class style/powered-by)}
        [:span
         "powered by"]
        [:svg {:xmlns "http://www.w3.org/2000/svg"
               :width "65"
               :class "icon"
               :viewBox "0 0 160 40"
               :fill "currentColor"}
         [:g {:clip-path "url(#clip0_644_2369)"}
          [:path {:d "M0 30.5763V27.9104L10.7573 13.8686H0.697717V9.23242H18.1427V11.8983L7.38539 25.8318H18.5134V30.5784H0V30.5763Z" :fill "currentColor"}]
          [:path {:d "M120.327 19.9195C120.327 27.207 115.468 31.0538 109.355 31.0538C103.242 31.0538 98.3828 27.207 98.3828 19.9195C98.3828 12.632 103.242 8.78516 109.355 8.78516C115.468 8.78516 120.327 12.632 120.327 19.9195ZM103.25 19.9195C103.25 24.1578 105.793 26.5322 109.355 26.5322C112.916 26.5322 115.459 24.1578 115.459 19.9195C115.459 15.6811 112.916 13.3068 109.355 13.3068C105.793 13.3068 103.25 15.6811 103.25 19.9195Z" :fill "currentColor"}]
          [:path {:d "M75.5206 13.8689H71.2031V9.21819H75.5352V7.15837C75.5352 2.83877 78.5427 0 83.1601 0H86.8341V4.51121H81.2627C80.7858 4.51121 80.4005 4.89651 80.4005 5.37346V9.21819H86.8361V13.8689H80.4005V30.5767H75.5227V13.8689H75.5206Z" :fill "currentColor"}]
          [:path {:d "M90.5273 0H95.3926V30.5767H90.5273V0Z" :fill "currentColor"}]
          [:path {:d "M38.3042 12.3173V9.22028H43.1716V30.5788H38.3042V27.3005C38.3042 27.1589 38.1897 27.0423 38.046 27.0423C37.9481 27.0423 37.8606 27.0985 37.8169 27.186C36.5985 29.6186 34.649 31.2286 30.9564 31.2286C24.6311 31.2723 19.9512 27.3734 19.9512 19.8776C19.9512 12.3819 24.8477 8.65586 31.0855 8.6996C34.5657 8.6996 36.5902 10.3866 37.8106 12.4506C37.8585 12.5318 37.9439 12.5818 38.0377 12.5818C38.1835 12.5818 38.3022 12.4631 38.3022 12.3173H38.3042ZM38.3605 19.9214C38.3605 16.2849 35.9049 13.3087 31.7478 13.3087C27.5906 13.3087 25.1351 16.2849 25.1351 19.9214C25.1351 23.5578 27.8281 26.5341 31.7478 26.5341C35.6675 26.5341 38.3605 23.5578 38.3605 19.9214Z" :fill "currentColor"}]
          [:path {:d "M51.8517 12.3173V9.22028H46.9844V39.5033H51.8517V27.3005C51.8517 27.1589 51.9663 27.0423 52.11 27.0423C52.2079 27.0423 52.2954 27.0985 52.3391 27.186C53.5575 29.6186 55.5069 31.2286 59.1996 31.2286C65.5249 31.2723 70.2048 27.3734 70.2048 19.8776C70.2048 12.3819 65.3083 8.65586 59.0705 8.6996C55.5902 8.6996 53.5658 10.3866 52.3453 12.4506C52.2974 12.5318 52.212 12.5818 52.1183 12.5818C51.9725 12.5818 51.8538 12.4631 51.8538 12.3173H51.8517ZM51.7955 19.9214C51.7955 16.2849 54.251 13.3087 58.4082 13.3087C62.5653 13.3087 65.0209 16.2849 65.0209 19.9214C65.0209 23.5578 62.3279 26.5341 58.4082 26.5341C54.4885 26.5341 51.7955 23.5578 51.7955 19.9214Z" :fill "currentColor"}]
          [:path {:d "M155.018 0L146.781 27.1068C146.746 27.2255 146.635 27.3068 146.513 27.3068C146.39 27.3068 146.279 27.2255 146.244 27.1068L141.637 11.9445L145.059 0.820598V0H140.077L131.84 27.1068C131.804 27.2255 131.694 27.3068 131.571 27.3068C131.448 27.3068 131.338 27.2255 131.302 27.1068L125.871 9.23277H120.92V10.0409L127.239 30.5787H135.899L138.769 21.2502C138.804 21.1315 138.915 21.0523 139.038 21.0523C139.161 21.0523 139.271 21.1335 139.306 21.2502L142.176 30.5787H150.836L160 0.820598V0H155.018Z" :fill "currentColor"}]]
         [:defs
          [:clipPath#clip0_644_2369
           [:rect {:width "160" :height "39.5033" :fill "currentColor"}]]]]]]]]))
